import { useTranslation } from "react-i18next"
import { Flex } from "antd"
import { Title } from "ui/Typography"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"
import UpcomingBookingItem from "./UpcomingBookingItem"
import LoadMoreButton from "components/common/LoadMore"
import styles from "./index.module.css"
import FirstLoading from "modules/loader-watchers/FirstLoading"

const UpcomingBookingListing = ({ bookings, onLoadMore, currentPage, totalPages, loading }) => {
  const { t } = useTranslation()
  const isLoadMoreVisible = currentPage < totalPages
  return (
    <FirstLoading loading={loading}>
      <Flex vertical gap={spacings.XS}>
        <Title level={4}>{t("settings.upcoming_bookings")}</Title>
        <div className={styles.upcomingBookingListingContainer}>
          {bookings?.map((booking) => (
            <UpcomingBookingItem key={booking?.id} booking={booking} />
          ))}
        </div>
        {isLoadMoreVisible && (
          <Flex justify="center">
            <LoadMoreButton currentPage={currentPage} totalPages={totalPages} onLoadMore={onLoadMore} />
          </Flex>
        )}
      </Flex>
    </FirstLoading>
  )
}

UpcomingBookingListing.propTypes = {
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.string,
      time: PropTypes.string,
      title: PropTypes.string,
      guest: PropTypes.string
    })
  ),
  onLoadMore: PropTypes.func,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  loading: PropTypes.bool
}

export default UpcomingBookingListing
